"use client";
import React from 'react';

const serviceLinks = [
  'Temporary Staffing',
  'Contract Staffing',
  'Blue Collar Staffing',
  'Overseas Recruitment',
  'Local Recruitment',
  'HR Consulting',
];

const sectorLinks = [
  'Oil & Gas',
  'Construction',
  'Infrastructure',
  'Logistics',
  'Airport & Seaport',
  'Power & Utility',
];

const companyLinks = [
  { label: 'About Us', href: '#about' },
  { label: 'Services', href: '#services' },
  { label: 'Sectors', href: '#sectors' },
  { label: 'Our Clients', href: '#clients' },
  { label: 'Contact', href: '#contact' },
  { label: 'Privacy Policy', href: '#' },
];

export default function Footer() {
  const handleScroll = (href: string) => {
    const id = href.replace('#', '');
    const el = document.getElementById(id);
    if (el) el.scrollIntoView({ behavior: 'smooth' });
  };

  return (
    <footer
      className="relative pt-16 pb-8"
      style={{
        background: '#020d1f',
        borderTop: '1px solid transparent',
        backgroundImage: 'linear-gradient(#020d1f, #020d1f), linear-gradient(90deg, transparent, #00c2ff, #1a56b0, transparent)',
        backgroundOrigin: 'border-box',
        backgroundClip: 'padding-box, border-box',
      }}
    >
      {/* Top cyan border */}
      <div className="absolute top-0 left-0 right-0 h-[1px]" style={{ background: 'linear-gradient(90deg, transparent, #00c2ff, #1a56b0, transparent)' }} />

      <div className="max-w-[1280px] mx-auto px-6">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-10 mb-12">
          {/* Col 1: Logo + Tagline */}
          <div>
            <div className="flex items-center gap-3 mb-4">
              <img
                src="/assets/images/LOgo_Fornax-1773477681087.png"
                alt="Fornax Global Logo"
                className="h-12 w-auto object-contain"
              />
            </div>
            <p className="text-muted text-sm leading-relaxed mb-6" style={{ fontFamily: 'Plus Jakarta Sans, sans-serif' }}>
              Qatar's Premier Manpower & HR Solutions Partner. 100% Qatari-owned. 20+ years of excellence.
            </p>
            {/* Social Icons */}
            <div className="flex gap-3">
              {[
                { label: 'LinkedIn', href: 'https://www.linkedin.com/company/fornaxglobal', path: 'M20.447 20.452h-3.554v-5.569c0-1.328-.027-3.037-1.852-3.037-1.853 0-2.136 1.445-2.136 2.939v5.667H9.351V9h3.414v1.561h.046c.477-.9 1.637-1.85 3.37-1.85 3.601 0 4.267 2.37 4.267 5.455v6.286zM5.337 7.433a2.062 2.062 0 0 1-2.063-2.065 2.064 2.064 0 1 1 2.063 2.065zm1.782 13.019H3.555V9h3.564v11.452zM22.225 0H1.771C.792 0 0 .774 0 1.729v20.542C0 23.227.792 24 1.771 24h20.451C23.2 24 24 23.227 24 22.271V1.729C24 .774 23.2 0 22.222 0h.003z' },
                { label: 'Facebook', href: 'https://www.facebook.com/Fornaxglob', path: 'M24 12.073c0-6.627-5.373-12-12-12s-12 5.373-12 12c0 5.99 4.388 10.954 10.125 11.854v-8.385H7.078v-3.47h3.047V9.43c0-3.007 1.792-4.669 4.533-4.669 1.312 0 2.686.235 2.686.235v2.953H15.83c-1.491 0-1.956.925-1.956 1.874v2.25h3.328l-.532 3.47h-2.796v8.385C19.612 23.027 24 18.062 24 12.073z' },
                { label: 'Instagram', href: 'https://www.instagram.com/fornaxglobal', path: 'M12 2.163c3.204 0 3.584.012 4.85.07 3.252.148 4.771 1.691 4.919 4.919.058 1.265.069 1.645.069 4.849 0 3.205-.012 3.584-.069 4.849-.149 3.225-1.664 4.771-4.919 4.919-1.266.058-1.644.07-4.85.07-3.204 0-3.584-.012-4.849-.07-3.26-.149-4.771-1.699-4.919-4.92-.058-1.265-.07-1.644-.07-4.849 0-3.204.013-3.583.07-4.849.149-3.227 1.664-4.771 4.919-4.919 1.266-.057 1.645-.069 4.849-.069zM12 0C8.741 0 8.333.014 7.053.072 2.695.272.273 2.69.073 7.052.014 8.333 0 8.741 0 12c0 3.259.014 3.668.072 4.948.2 4.358 2.618 6.78 6.98 6.98C8.333 23.986 8.741 24 12 24c3.259 0 3.668-.014 4.948-.072 4.354-.2 6.782-2.618 6.979-6.98.059-1.28.073-1.689.073-4.948 0-3.259-.014-3.667-.072-4.947-.196-4.354-2.617-6.78-6.979-6.98C15.668.014 15.259 0 12 0zm0 5.838a6.162 6.162 0 1 0 0 12.324 6.162 6.162 0 0 0 0-12.324zM12 16a4 4 0 1 1 0-8 4 4 0 0 1 0 8zm6.406-11.845a1.44 1.44 0 1 0 0 2.881 1.44 1.44 0 0 0 0-2.881z' },
                { label: 'Telegram', href: 'https://t.me/fornaxgloabl', path: 'M11.944 0A12 12 0 0 0 0 12a12 12 0 0 0 12 12 12 12 0 0 0 12-12A12 12 0 0 0 12 0a12 12 0 0 0-.056 0zm4.962 7.224c.1-.002.321.023.465.14a.506.506 0 0 1 .171.325c.016.093.036.306.02.472-.18 1.898-.962 6.502-1.36 8.627-.168.9-.499 1.201-.82 1.23-.696.065-1.225-.46-1.9-.902-1.056-.693-1.653-1.124-2.678-1.8-1.185-.78-.417-1.21.258-1.91.177-.184 3.247-2.977 3.307-3.23.007-.032.014-.15-.056-.212s-.174-.041-.249-.024c-.106.024-1.793 1.14-5.061 3.345-.48.33-.913.49-1.302.48-.428-.008-1.252-.241-1.865-.44-.752-.245-1.349-.374-1.297-.789.027-.216.325-.437.893-.663 3.498-1.524 5.83-2.529 6.998-3.014 3.332-1.386 4.025-1.627 4.476-1.635z' },
                { label: 'X (Twitter)', href: '#', path: 'M18.244 2.25h3.308l-7.227 8.26 8.502 11.24H16.17l-4.714-6.231-5.401 6.231H2.744l7.737-8.835L1.254 2.25H8.08l4.253 5.622 5.911-5.622zm-1.161 17.52h1.833L7.084 4.126H5.117z' },
              ].map((social) => (
                <a
                  key={social.label}
                  href={social.href}
                  target="_blank"
                  rel="noopener noreferrer"
                  aria-label={social.label}
                  className="w-9 h-9 rounded-lg flex items-center justify-center transition-all duration-300 hover:scale-110"
                  style={{
                    background: 'rgba(10, 36, 80, 0.6)',
                    border: '1px solid rgba(255,255,255,0.08)',
                  }}
                  onMouseEnter={(e) => {
                    (e.currentTarget as HTMLElement).style.borderColor = 'rgba(0,194,255,0.4)';
                    (e.currentTarget as HTMLElement).style.background = 'rgba(0,194,255,0.1)';
                  }}
                  onMouseLeave={(e) => {
                    (e.currentTarget as HTMLElement).style.borderColor = 'rgba(255,255,255,0.08)';
                    (e.currentTarget as HTMLElement).style.background = 'rgba(10, 36, 80, 0.6)';
                  }}
                >
                  <svg width="16" height="16" viewBox="0 0 24 24" fill="#a8b8d8">
                    <path d={social.path} />
                  </svg>
                </a>
              ))}
            </div>
          </div>

          {/* Col 2: Services */}
          <div>
            <h4 className="text-fg font-bold text-sm uppercase tracking-[2px] mb-5" style={{ fontFamily: 'Plus Jakarta Sans, sans-serif' }}>
              Services
            </h4>
            <ul className="space-y-3">
              {serviceLinks.map((s) => (
                <li key={s}>
                  <button
                    onClick={() => handleScroll('#services')}
                    className="text-muted text-sm hover:text-cyan transition-colors duration-200 flex items-center gap-2 group"
                  >
                    <span className="w-1 h-1 rounded-full bg-accent group-hover:bg-cyan transition-colors duration-200 flex-shrink-0" />
                    {s}
                  </button>
                </li>
              ))}
            </ul>
          </div>

          {/* Col 3: Sectors */}
          <div>
            <h4 className="text-fg font-bold text-sm uppercase tracking-[2px] mb-5" style={{ fontFamily: 'Plus Jakarta Sans, sans-serif' }}>
              Sectors
            </h4>
            <ul className="space-y-3">
              {sectorLinks.map((s) => (
                <li key={s}>
                  <button
                    onClick={() => handleScroll('#sectors')}
                    className="text-muted text-sm hover:text-cyan transition-colors duration-200 flex items-center gap-2 group"
                  >
                    <span className="w-1 h-1 rounded-full bg-accent group-hover:bg-cyan transition-colors duration-200 flex-shrink-0" />
                    {s}
                  </button>
                </li>
              ))}
            </ul>
          </div>

          {/* Col 4: Company */}
          <div>
            <h4 className="text-fg font-bold text-sm uppercase tracking-[2px] mb-5" style={{ fontFamily: 'Plus Jakarta Sans, sans-serif' }}>
              Company
            </h4>
            <ul className="space-y-3">
              {companyLinks.map((l) => (
                <li key={l.label}>
                  <button
                    onClick={() => handleScroll(l.href)}
                    className="text-muted text-sm hover:text-cyan transition-colors duration-200 flex items-center gap-2 group"
                  >
                    <span className="w-1 h-1 rounded-full bg-accent group-hover:bg-cyan transition-colors duration-200 flex-shrink-0" />
                    {l.label}
                  </button>
                </li>
              ))}
            </ul>
          </div>
        </div>

        {/* Bottom Bar */}
        <div
          className="pt-6 flex flex-col md:flex-row items-center justify-between gap-4 text-xs text-muted"
          style={{ borderTop: '1px solid rgba(255,255,255,0.06)' }}
        >
          <p>© 2025 Fornax Global Contracting WLL. All rights reserved.</p>
          <div className="flex flex-col sm:flex-row items-center gap-3 sm:gap-6 text-center">
            <span>Office No: 202, 2nd Floor, Building No: 08, Zone 24, Al Muntazah, Doha, Qatar</span>
            <a href="mailto:info@fornaxglob.com" className="hover:text-cyan transition-colors">info@fornaxglob.com</a>
            <a href="tel:+97450018878" className="hover:text-cyan transition-colors">+974 5001 8878</a>
          </div>
        </div>
      </div>
    </footer>
  );
}